import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const fmtPrice = (n) => `€${Number(n ?? 0).toFixed(2).replace(".", ",")}`;

export const fmtTime = (s) => {
  if (!Number.isFinite(s)) return "0:00";
  const m = Math.floor(s / 60);
  return `${m}:${String(Math.floor(s % 60)).padStart(2, "0")}`;
};

export const FALLBACK_TRACKS = [
  { id: "rel-1", title: "Various Artists", artists: "Joker Riddim", format: "Joker Riddim", year: "2025", key: "2025", price: 10.00, cover: "/media/cover1.jpg", preview: "/media/audio/preview-rel-1.mp3", smallTitle: true,
    items: [
      { name: "No joke", artist: "Luciano", price: 0.99 }, { name: "One spliff", artist: "Mikey General", price: 0.99 }, { name: "Nah worry", artist: "Mistilla", price: 0.99 },
      { name: "Dare e avere", artist: "Fido Guido", price: 0.99 }, { name: "Reggae riddim", artist: "Quartiere Coffee", price: 0.99 }, { name: "Grateful", artist: "Jaka & Hi Kee", price: 0.99 },
      { name: "Music everyday", artist: "Raphael", price: 0.99 }, { name: "L'animu de nu soundboy", artist: "Papa Massi", price: 0.99 },
      { name: "Dancing feet", artist: "Slase Mashan", price: 0.99 },
      { name: "Brodo", artist: "Mark-One", price: 0.99 }, { name: "Good times", artist: "Star Social", price: 0.99 }, { name: "Fi di gyal dem", artist: "G.Man", price: 0.99 },
    ] },
  { id: "rel-2", title: "Kumar Fyah", artists: "Sweet Reggae", label: "Turn back riddim", format: "Single · Digital", year: "2026", bpm: 78, key: "2026", price: 0.99, cover: "/media/cover2.jpg", preview: "/media/audio/preview-rel-2.wav", previewSeconds: 40 },
  { id: "rel-3", title: "Kumar Fyah", artists: "Sweet Reggae 7inch", format: "Riddim · Digital", year: "2025", bpm: 76, key: "2026", price: 13.00, cover: "/media/cover3.jpg", preview: "/media/audio/preview-rel-3.wav", previewSeconds: 40 },
  { id: "rel-4", title: "Mikey General", artists: "One Spliff 7inch", format: "Riddim · Digital", year: "2025", bpm: 82, key: "2026", price: 12.00, cover: "/media/cover4.jpg", preview: "/media/audio/preview-rel-4.wav", previewSeconds: 40 },
];

FALLBACK_TRACKS[0].items.forEach((it, i) => {
  it.preview = `/media/audio/preview-rel-1-${String(i + 1).padStart(2, "0")}.wav`;
  it.previewSeconds = 40;
});

export async function startCheckout(trackId, item = null) {
  const { data } = await http.post("/payments/checkout", { track_id: trackId, origin_url: window.location.origin, item });
  if (data?.checkout_url) window.location.href = data.checkout_url;
}
